/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 企業のプレスキットの一括ダウンロードを開始した後の確認用のURL
 * @export
 * @interface PressKitBatchDownloadResult
 */
export interface PressKitBatchDownloadResult {
    /**
     * 確認用のURL。クエリパラメータのcheck_keyはランダムな文字列。将来URLやクエリパラメーターが変わる可能性がある。
     * @type {string}
     * @memberof PressKitBatchDownloadResult
     */
    readonly checkResultUrl?: string;
}

export function PressKitBatchDownloadResultFromJSON(json: any): PressKitBatchDownloadResult {
    return PressKitBatchDownloadResultFromJSONTyped(json, false);
}

export function PressKitBatchDownloadResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitBatchDownloadResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'checkResultUrl': !exists(json, 'check_result_url') ? undefined : json['check_result_url'],
    };
}

export function PressKitBatchDownloadResultToJSON(value?: PressKitBatchDownloadResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

